var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b, _c, _d, _e;
import { fetchApi } from '@api-gen';
import { Guidebooks } from '../types';
var getGuidebooksPaginatedApiMap = (_a = {},
    _a[Guidebooks.ISSUER] = fetchApi.api.issuerGetPaginatedCreate,
    _a[Guidebooks.CONSTRUCTION] = fetchApi.api.constructionGetPaginatedCreate,
    _a[Guidebooks.MATERIAL] = fetchApi.api.materialGetPaginatedCreate,
    _a[Guidebooks.REQUIREMENT] = fetchApi.api.requirementGetPaginatedCreate,
    _a);
var getGuidebooksDetailApiMap = (_b = {},
    _b[Guidebooks.ISSUER] = fetchApi.api.issuerDetail,
    _b[Guidebooks.CONSTRUCTION] = fetchApi.api.constructionDetail,
    _b[Guidebooks.MATERIAL] = fetchApi.api.materialDetail,
    _b[Guidebooks.REQUIREMENT] = fetchApi.api.requirementDetail,
    _b);
var getGuidebooksCreateApiMap = (_c = {},
    _c[Guidebooks.ISSUER] = fetchApi.api.issuerCreate,
    _c[Guidebooks.CONSTRUCTION] = fetchApi.api.constructionCreate,
    _c[Guidebooks.MATERIAL] = fetchApi.api.materialCreate,
    _c[Guidebooks.REQUIREMENT] = fetchApi.api.requirementCreate,
    _c);
var getGuidebooksEditApiMap = (_d = {},
    _d[Guidebooks.ISSUER] = fetchApi.api.issuerUpdate,
    _d[Guidebooks.CONSTRUCTION] = fetchApi.api.constructionUpdate,
    _d[Guidebooks.MATERIAL] = fetchApi.api.materialUpdate,
    _d[Guidebooks.REQUIREMENT] = fetchApi.api.requirementUpdate,
    _d);
var getGuidebooksDeleteApiMap = (_e = {},
    _e[Guidebooks.ISSUER] = fetchApi.api.issuerDelete,
    _e[Guidebooks.CONSTRUCTION] = fetchApi.api.constructionDelete,
    _e[Guidebooks.MATERIAL] = fetchApi.api.materialDelete,
    _e[Guidebooks.REQUIREMENT] = fetchApi.api.requirementDelete,
    _e);
export var getGuidebooksPaginated = function (_a) {
    var data = _a.data, guidebookType = _a.guidebookType, pagination = _a.pagination;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getGuidebooksPaginatedApiMap[guidebookType](__assign(__assign({}, data), { pageNumber: pagination.pageNumber, pageSize: pagination.pageSize }))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
export var getGuidebooksDetail = function (_a) {
    var id = _a.id, guidebookType = _a.guidebookType;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getGuidebooksDetailApiMap[guidebookType](id)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
export var getGuidebooksCreate = function (_a) {
    var data = _a.data, guidebookType = _a.guidebookType;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getGuidebooksCreateApiMap[guidebookType](data)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
export var getGuidebooksEdit = function (_a) {
    var data = _a.data, guidebookType = _a.guidebookType;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getGuidebooksEditApiMap[guidebookType](data)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
export var getGuidebooksDelete = function (_a) {
    var data = _a.data, guidebookType = _a.guidebookType;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getGuidebooksDeleteApiMap[guidebookType](data)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
export var getGuidebooksMaterialTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchApi.api.materialTypeList()];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getGuidebooksConstructionTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchApi.api.constructionConstructionTypesList()];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getFirstPlacementRoomVariant = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchApi.api.placementRoomVariantsCreate(data)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getSecondRoomVariant = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchApi.api.placementRoomVariantsGetSecondRoomCreate(data)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
